import {ProjectsEditAPI} from "../../api/api.js";
import {makeTree, sortArrayByName} from "../../utils/treeUtils.js";
import {createErrorNotification, createSuccessNotification} from "./notification-reducer.js";

const SET_START_LOADING = 'projectsEditReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'projectsEditReducer/SET_STOP_LOADING'
const SET_COMPANIES_TREE = 'projectsEditReducer/SET_COMPANIES_TREE'
const SET_COMPANIES = 'projectsEditReducer/SET_COMPANIES'
const SET_CONTRACTS = 'projectsEditReducer/SET_CONTRACTS'
const SET_PROJECTS = 'projectsEditReducer/SET_PROJECTS'

const initialState = {
    loading: false,
    companiesTree: [],
    companies: [],
    contracts: [],
    projects: []
}

export const projectsEditReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_STOP_LOADING:
            return {
                ...state,
                loading: false
            }

        case SET_COMPANIES_TREE:
            return {
                ...state,
                companiesTree: action.nodes
            }

        case SET_COMPANIES:
            return {
                ...state,
                companies: action.companies
            }

        case SET_CONTRACTS:
            return {
                ...state,
                contracts: action.contracts
            }

        case SET_PROJECTS:
            return {
                ...state,
                projects: action.projects
            }

        default:
            return state
    }
}


export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.projectsEditReducer.loading

export const setCompaniesTree = (nodes) => ({type: SET_COMPANIES_TREE, nodes})
export const selectCompaniesNodes = (state) => state.projectsEditReducer.companiesTree

export const setCompanies = (companies) => ({type: SET_COMPANIES, companies})
export const selectCompanies = (state) => state.projectsEditReducer.companies

export const setContracts = (contracts) => ({type: SET_CONTRACTS, contracts})
export const selectContracts = (state) => state.projectsEditReducer.contracts

export const setProjects = (projects) => ({type: SET_PROJECTS, projects})
export const selectProjects = (state) => state.projectsEditReducer.projects


export const getCompaniesNodes = () => async (dispatch) => {
    const companiesResponse = await ProjectsEditAPI.getCompanies()
    const contractsResponse = await ProjectsEditAPI.getContracts()
    const projectsResponse = await ProjectsEditAPI.getProjects()

    const companies = companiesResponse.data
        .map(company => ({...company, type: 'company'}))
        .sort(sortArrayByName())

    const contracts = contractsResponse.data
        .map(contract => ({...contract, type: 'contract'}))
        .sort(sortArrayByName())

    const projects = projectsResponse.data
        .map(project => ({...project, type: 'project'}))
        .sort(sortArrayByName())

    const config = [
        {
            parentPosition: 0,
            parentKey: 'company',
            root: true,
            rootValue: null
        },
        {
            parentPosition: 0,
            parentKey: 'company',
            root: false,
            rootValue: null
        },
        {
            parentPosition: 1,
            parentKey: 'contract',
            root: false,
            rootValue: null
        },
    ]

    await dispatch(setCompanies(companies))
    await dispatch(setContracts(contracts))
    await dispatch(setProjects(projects))
    await dispatch(setCompaniesTree(makeTree([companies, contracts, projects], config)))
}

export const createCompany = (values) => async () => {
    await ProjectsEditAPI.createCompany(values)
}

export const updateCompany = (values) => async () => {
    await ProjectsEditAPI.updateCompany(values)
}

export const createContract = (values) => async () => {
    await ProjectsEditAPI.createContract(values)
}

export const updateContract = (values) => async () => {
    await ProjectsEditAPI.updateContract(values)
}

export const createProject = (values) => async () => {
    await ProjectsEditAPI.createProject(values)
}

export const copyProject = (id) => async () => {
    await ProjectsEditAPI.copyProject(id)
}

export const updateProject = (values) => async () => {
    await ProjectsEditAPI.updateProject(values)
}

export const deleteElement = (node) => async () => {
    const [type, id] = node?.split('.') || []
    if (type === 'company') await ProjectsEditAPI.deleteCompany(id)
    if (type === 'contract') await ProjectsEditAPI.deleteContract(id)
    if (type === 'project') await ProjectsEditAPI.deleteProject(id)
}

export const moveProjectTreeElement = (node, parentNode) => async (dispatch) => {
    const [type, id] = node.split('.')
    const [parentType, parentID] = parentNode.split('.')

    if (type === 'company' && parentType === 'company' && parentID === id) {
        await dispatch(createErrorNotification('Нельзя переместить компанию саму в себя'))
        return null
    }

    if (type === 'company' && parentType === 'contract') {
        await dispatch(createErrorNotification('Нельзя переместить компанию в договор'))
        return null
    }

    if (type === 'company' && parentType === 'project') {
        await dispatch(createErrorNotification('Нельзя переместить компанию в тип акта'))
        return null
    }

    if (type === 'contract' && !Boolean(parentType)) {
        await dispatch(createErrorNotification('Нельзя переместить договор в корень'))
        return null
    }

    if (type === 'contract' && parentType === 'contract') {
        await dispatch(createErrorNotification('Нельзя переместить договор в договор'))
        return null
    }

    if (type === 'contract' && parentType === 'project') {
        await dispatch(createErrorNotification('Нельзя переместить договор в тип акта'))
        return null
    }

    if (type === 'project' && !Boolean(parentType)) {
        await dispatch(createErrorNotification('Нельзя переместить тип акта в корень'))
        return null
    }

    if (type === 'project' && parentType === 'company') {
        await dispatch(createErrorNotification('Нельзя переместить тип акта в компанию'))
        return null
    }

    if (type === 'project' && parentType === 'project') {
        await dispatch(createErrorNotification('Нельзя переместить тип акта в тип акта'))
        return null
    }


    try {
        if (type === 'company') await ProjectsEditAPI.updateCompany({id, company: parentID || null})
        if (type === 'contract') await ProjectsEditAPI.updateContract({id, company: parentID})
        if (type === 'project') await ProjectsEditAPI.updateProject({id, contract: parentID})

        await dispatch(createSuccessNotification('Успешная вставка'))
    } catch {
        await dispatch(createErrorNotification('При вставке произошла ошибка'))
        return null
    }
}